<template>
  <div class="mainCommonListContainer">
    <div class="buttonContainer">
      <div class="addDiv">
        <el-button @click="add()" v-if="null !== addPermission" class="addBtn"
          >{{ addPermission.name }}<i class="el-icon-plus el-icon--right"></i
        ></el-button>
      </div>

      <div id="queryDiv">
        <el-form :model="queryForm" @submit.native.prevent>
          <el-form-item label="">
            <el-input
              v-model="queryForm.name"
              placeholder="搜索通讯站名称"
              @keyup.enter.native="handleCurrentChange(1)"
              ><i
                class="el-icon-search"
                slot="suffix"
                @click="handleCurrentChange(1)"
              >
              </i
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        height="491"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="name"
          label="名称"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="type"
          label="类型"
          min-width="40"
          align="center"
          :formatter="formatterType"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="lon"
          label="经度(度)"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="lat"
          label="纬度(度)"
          min-width="60"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="alt"
          label="高度(米)"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="radius"
          label="半径(米)"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="link_type"
          label="链路类型"
          min-width="40"
          align="center"
          :formatter="formatterLinkType"
          :show-overflow-tooltip="true"
        ></el-table-column
        ><el-table-column
          prop="frequency_range"
          label="通信频率范围"
          min-width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="available_frequency"
          label="可用频点"
          min-width="40"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="操作"
          min-width="80"
          align="center"
          v-if="buttonList.length !== 0"
        >
          <template slot-scope="scope">
            <div class="buttonCol">
              <div
                v-for="(button, index) in buttonList"
                :key="index"
                class="buttonClass"
              >
                <el-button
                  v-if="button.path === 'comStationList-edit'"
                  @click="edit(scope.row)"
                  icon="el-icon-operte-view"
                  class="editBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                ><el-button
                  v-else-if="button.path === 'comStationList-del'"
                  @click="del(scope.row)"
                  icon="el-icon-operte-view"
                  class="delBtn"
                  style="margin-right: 10px"
                  >{{ button.name }}</el-button
                >
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="
          text-align: right;
          margin-top: 15px;
          margin-right: 0px;
          height: 40px;
        "
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination
        ><!-- , jumper -->
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="812px"
      class="commonComplexDialog"
    >
      <div class="dialog-header-separator"></div>
      <el-form
        :rules="rules"
        ref="commonForm"
        :model="commonForm"
        label-width="100px"
        @submit.native.prevent
      >
        <el-form-item label="通讯站名称" prop="name" class="left-form-item">
          <el-input
            v-model="commonForm.name"
            maxlength="50"
            placeholder="请输入通讯站名称"
            @keyup.enter.native="submit('commonForm')"
          ></el-input> </el-form-item
        ><el-form-item label="频率范围" prop="frequency_range">
          <el-input
            v-model="commonForm.frequency_range"
            placeholder="请输入频率范围"
            maxlength="64"
            @keyup.enter.native="submit('commonForm')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="经度(度)"
          prop="lon"
          class="number-adjust-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button icon="el-icon-plus" @click="addPoint('lon')"></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.lon"
              placeholder="请输入经度"
              maxlength="11"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('lon')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="纬度(度)"
          prop="lat"
          class="number-adjust-item left-form-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button icon="el-icon-plus" @click="addPoint('lat')"></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.lat"
              placeholder="请输入纬度"
              maxlength="10"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('lat')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="高度(米)"
          prop="alt"
          class="number-adjust-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button icon="el-icon-plus" @click="addPoint('alt')"></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model="commonForm.alt"
              placeholder="请输入高度"
              maxlength="7"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('alt')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="半径(米)"
          prop="radius"
          class="number-adjust-item left-form-item"
          label-width="100px"
        >
          <div style="width: 100%; height: 40px; display: block">
            <el-button
              icon="el-icon-plus"
              @click="addPoint('radius')"
            ></el-button>
            <el-input
              @keyup.enter.native="submit('commonForm')"
              v-model.number="commonForm.radius"
              placeholder="请输入半径"
              maxlength="10"
            ></el-input>
            <el-button
              icon="el-icon-minus"
              @click="reducePoint('radius')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item label="通讯站类型" prop="type" label-width="100px">
          <el-select
            v-model="commonForm.type"
            placeholder="请选择通讯站类型"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="type in types"
              :key="type.id"
              :label="type.name"
              :value="type.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链路类型"
          prop="link_type"
          label-width="100px"
          class="left-form-item"
        >
          <el-select
            v-model="commonForm.link_type"
            placeholder="请选择链路类型"
            popper-class="adminHomeSelect"
            clearable
          >
            <el-option
              v-for="linkType in linkTypes"
              :key="linkType.id"
              :label="linkType.name"
              :value="linkType.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="频点"
          prop="available_frequency"
          class="left-form-item"
        >
          <el-input
            @keyup.enter.native="submit('commonForm')"
            v-model.number="commonForm.available_frequency"
            placeholder="请输入频点"
            maxlength="4"
          ></el-input>
        </el-form-item>
        <el-form-item class="formItemBtnRow">
          <el-button
            type="primary"
            @click="submit('commonForm')"
            class="confirmBtn"
            >确 定</el-button
          ><el-button @click="dialogVisible = false" class="cancelBtn"
            >取 消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "comStationList",
  props: ["menuId"],
  data() {
    var checkLgn = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,6})?$/;
        if (reg.test(value)) {
          if (180 < value) {
            callback(new Error("经度不能大于180~"));
          } else if (value < -180) {
            callback(new Error("经度不能小于-180~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("经度小数位数不能超过六位~"));
        }
      } else {
        callback();
      }
    };
    var checkLat = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,6})?$/;
        if (reg.test(value)) {
          if (90 < value) {
            callback(new Error("纬度不能大于90~"));
          } else if (value < -90) {
            callback(new Error("纬度不能小于-90~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("纬度小数位数不能超过六位~"));
        }
      } else {
        callback();
      }
    };
    var checkAltitude = (rule, value, callback) => {
      if (value) {
        value = Number(value);
        var reg = /^-?\d+(\.\d{1,2})?$/;
        if (reg.test(value)) {
          if (8845 < value) {
            callback(new Error("高度不能大于8845米~"));
          } else if (value < -413) {
            callback(new Error("高度不能小于-413米~"));
          } else {
            callback();
          }
        } else {
          callback(new Error("高度小数位数不能超过两位~"));
        }
      } else {
        callback();
      }
    };
    return {
      queryForm: {},
      title: "添加通讯站",
      addPermission: null,
      buttonList: [],
      commonForm: {},
      current: 1, //当前页数
      size: 18, //显示几条
      totalCount: 0, //总条数
      tableData: [],
      dialogVisible: false,
      addFlag: true,
      types: [
        {
          id: 0,
          name: "固定",
        },
        {
          id: 1,
          name: "临时",
        },
      ],
      linkTypes: [
        {
          id: 0,
          name: "M4G",
        },
        {
          id: 1,
          name: "J4G",
        },
        {
          id: 2,
          name: "M5G",
        },
        {
          id: 3,
          name: "J5G",
        },
        {
          id: 4,
          name: "电台",
        },
        {
          id: 5,
          name: "卫通",
        },
      ],
      rules: {
        name: [
          { required: true, trigger: "blur", message: "通讯站名称不能为空~" },
        ],
        type: [{ required: false, trigger: "blur" }],
        lon: [{ required: false, validator: checkLgn, trigger: "blur" }],
        lat: [{ required: false, validator: checkLat, trigger: "blur" }],
        alt: [{ required: false, validator: checkAltitude, trigger: "blur" }],
        radius: [
          { required: false, trigger: "blur" },
          {
            type: "number",
            min: 1,
            max: 2147483647,
            message: "半径在1-2147483647之间~",
          },
        ],
        link_type: [{ required: false, trigger: "blur" }],
        frequency_range: [{ required: false, trigger: "blur" }],
        available_frequency: [
          { required: false, trigger: "blur" },
          {
            type: "number",
            min: 1,
            max: 3000,
            message: "频点在1-3000之间~",
          },
        ],
      },
      pointRange: {
        lon: { min: -180, max: 180 },
        lat: { min: -90, max: 90 },
        alt: { min: -413, max: 8845 },
        radius: { min: 1, max: 2147483647 },
        available_frequency: { min: 1, max: 3000 },
      },
    };
  },
  mounted() {
    this.setGutterWidth();
    this.query();
    this.buttonList = [];
    this.addPermission = null;
    this.$emit("getMenuList", this.menuId, 1, 0, this.getButtonList);
  },
  methods: {
    getButtonList(buttonList) {
      let menuId = this.menuId;
      for (
        let i = 0, len = buttonList.length;
        i < len && this.buttonList.length === 0;
        i++
      ) {
        let button = buttonList[i];
        if (button) {
          let children = button.children;
          if (children) {
            children.forEach((child) => {
              this.getChildren(child);
            });
          }
        }
      }
    },
    getChildren(item) {
      let menuId = item.id;
      let children = item.children;
      if (this.menuId === menuId) {
        let otherButton = [];
        for (let i = 0, len = children.length; i < len; i++) {
          let child = children[i];
          if (child) {
            if (child.path === "comStationList-add") {
              this.addPermission = child;
            } else if (child.path !== "comStationList-view") {
              otherButton.push(child);
            }
          }
        }
        this.buttonList = otherButton;
      } else {
        if (children) {
          children.forEach((child) => {
            this.getChildren(child);
          });
        }
      }
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    },
    addPoint(type) {
      this.addOrReducePoint(type, true);
    },
    reducePoint(type) {
      this.addOrReducePoint(type, false);
    },
    addOrReducePoint(type, add) {
      let data = 0;
      if (
        this.$data.commonForm[type] &&
        parseFloat(this.$data.commonForm[type])
      ) {
        data = parseFloat(this.$data.commonForm[type]);
      }
      if (add) {
        data += 1;
      } else {
        data -= 1;
      }
      const rules = this.$data.pointRange[type];
      if (null != rules && rules.min <= data && data <= rules.max) {
        this.$set(this.$data.commonForm, type, data);
        this.$refs.commonForm.validateField(type);
      } else if (
        (!this.$data.commonForm[type] || isNaN(this.$data.commonForm[type])) &&
        !add &&
        data < rules.min
      ) {
        this.$set(this.$data.commonForm, type, rules.min);
        this.$refs.commonForm.validateField(type);
      } else if (!add && rules.max < data) {
        this.$set(this.$data.commonForm, type, rules.max);
        this.$refs.commonForm.validateField(type);
      } else if (add && data < rules.min) {
        this.$set(this.$data.commonForm, type, rules.min);
        this.$refs.commonForm.validateField(type);
      }
    },
    add() {
      this.$data.title = "添加通讯站";
      this.$data.addFlag = true;
      this.$data.dialogVisible = true;
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.$data.addFlag) {
          this.addCommStation();
        } else if (valid && !this.$data.addFlag) {
          this.editCommStation();
        } else {
          return false;
        }
      });
    },
    addCommStation() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/commstation/addCommStation.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    },
    query() {
      let vue = this;
      this.getRequest(
        "/basic-info-server/commstation/getCommStationList.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   cofnfirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑
    edit(row) {
      this.doEdit(row.id);
    },
    doEdit(id) {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/commstation/getCommStationById.do",
        {
          id: id,
        }
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              this.$data.title = "修改通讯站";
              this.$data.addFlag = false;
              this.$data.commonForm = res.data;
              this.$data.dialogVisible = true;
            } else {
              // let tips =
              //   "<i class='el-icon-warn-tip'></i> 啊哦,请求数据不存在~";
              // this.$confirm(tips, "提示", {
              //   confirmButtonText: "好的",
              //   customClass: "customClass-style",
              //   iconClass: "",
              //   dangerouslyUseHTMLString: true,
              //   confirmButtonClass: "confirm-style",
              //   showCancelButton: false,
              // });
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    //编辑提交
    editCommStation() {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/commstation/upateCommStation.do",
        this.$data.commonForm
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            vue.$data.dialogVisible = false;
            vue.query();
            vue.$message({
              message: "提交成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
          //提示消息
          vue.$message({
            customClass: "message-s",
            message: msg,
            type: type,
          });
        })
        .catch((error) => {});
    }, //删除
    del(row) {
      let tips =
        "<i class='el-icon-warn-tip'></i>将永久删除该条记录, 是否继续?";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "customClass-style",
        iconClass: "",
        dangerouslyUseHTMLString: true,
        confirmButtonClass: "confirm-style",
        cancelButtonClass: "cancel-style",
      })
        .then(() => {
          this.doDel(row);
        })
        .catch(() => {});
    },
    doDel(row) {
      let vue = this;
      this.postJsonRequest(
        "/basic-info-server/commstation/DelCommStation.do",
        row
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            let totalPage = Math.ceil((this.totalCount - 1) / this.size);
            let currentPage =
              this.current > totalPage ? totalPage : this.current;
            this.current = currentPage < 1 ? 1 : currentPage;
            vue.query();
            vue.$message({
              message: "删除成功",
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {},
            });
          } else if (res.code != 401) {
            let msg = "请求失败";
            if (null != res) {
              msg = res.msg;
            }
            let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            this.$confirm(tips, "提示", {
              confirmButtonText: "好的",
              customClass: "customClass-style",
              iconClass: "",
              dangerouslyUseHTMLString: true,
              confirmButtonClass: "confirm-style",
              showCancelButton: false,
            });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    formatterType(row, column, value) {
      if (this.$data.types[value]) {
        return this.$data.types[value].name;
      }
      return "";
    },
    formatterLinkType(row, column, value) {
      if (this.$data.linkTypes[value]) {
        return this.$data.linkTypes[value].name;
      }
      return "";
    },
  },
  watch: {
    dialogVisible: function (nval, oval) {
      if (!nval) {
        this.$data.commonForm = {};
      }
      this.defaultClearValidate();
    },
  },
};
</script>

<style>
.mainCommonListContainer {
  width: 100%;
  height: 100%;
}

.adminHomeContainer
  .el-tabs
  .el-tabs__content
  #pane-stationList
  .commonDialog
  .el-dialog {
  margin-top: calc(25% - 260px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/link/comStation.vue